import React, { useState, useEffect } from 'react';
import image from '../../../assets/settings.gif';
const MIPEmonitoreo = () => {

    useEffect(() => {

    }, []);

    return (
        <div className='w-100 overflow bg-white m-0 p-1 overflow relative border round-m shadow-sm dosis' style={{ height: "calc(100vh - 60px)" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className='w-100 mt-5 h1 text-center mb-3'>En construcción</div>
                <img src={image} style={{ height: "300px", width: "auto" }} />
            </div>
        </div >
    )
}

export default MIPEmonitoreo;